export interface Comic {
  id: string;
  title: string;
  genres: string[];
  author: string;
  status: "连载中" | "已完结";
  totalChapters: number;
  latestChapter: number;
  updateDay: string;
  rating: number;
  heat: number;
  views: string;
  synopsis: string;
  cover: string;
  isTop?: boolean;
}

export const comics: Comic[] = [
  {
    id: "xinghai-huixiang",
    title: "星海回响",
    genres: ["热血冒险", "科幻", "国漫"],
    author: "鱼眠",
    status: "连载中",
    totalChapters: 288,
    latestChapter: 214,
    updateDay: "周五",
    rating: 9.6,
    heat: 9820,
    views: "3.2亿",
    synopsis: "宇宙拓荒时代，少年回声觉醒星海共鸣之力，驾驶旧式航舰闯入失落星域，揭开父辈失踪背后的惊天秘密。",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20manga%20cover%20of%20a%20heroic%20young%20space%20adventurer%20holding%20a%20glowing%20energy%20sword%20under%20a%20starry%20cosmic%20sky%2C%20vibrant%20warm%20orange%20and%20coral%20nebula%20background%2C%20dynamic%20action%20pose%2C%20detailed%20line%20art%2C%20clean%20composition%2C%20high%20quality%20manga%20cover%20illustration&width=420&height=580&seq=cover-xinghai-01&orientation=portrait",
    isTop: true,
  },
  {
    id: "wudu-shilinglu",
    title: "雾都食灵录",
    genres: ["奇幻", "美食", "治愈"],
    author: "阿茶茶",
    status: "连载中",
    totalChapters: 176,
    latestChapter: 141,
    updateDay: "周三",
    rating: 9.4,
    heat: 8150,
    views: "2.1亿",
    synopsis: "雾都深处的小餐馆，年轻主厨能用一碗热汤召唤食灵，替迷途灵魂完成最后的心愿，暖胃更暖心。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20dark%20fantasy%20manga%20cover%20of%20a%20young%20chef%20with%20glowing%20warm%20lanterns%20surrounded%20by%20tiny%20luminous%20food%20spirits%20in%20a%20misty%20city%2C%20warm%20orange%20and%20amber%20lighting%2C%20detailed%20artwork%2C%20charming%20atmosphere&width=420&height=580&seq=cover-wudu-02&orientation=portrait",
  },
  {
    id: "jianming-shanhai",
    title: "剑鸣山海",
    genres: ["武侠", "玄幻", "国漫"],
    author: "墨羽",
    status: "连载中",
    totalChapters: 321,
    latestChapter: 287,
    updateDay: "周日",
    rating: 9.5,
    heat: 9200,
    views: "4.0亿",
    synopsis: "山海关外的无名剑客，携一柄断剑踏遍九州，在刀光剑影与家国恩怨间，寻回失传的剑鸣心法。",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20wuxia%20manga%20cover%20of%20a%20flowing%20robed%20swordsman%20standing%20on%20a%20mountain%20peak%20at%20dawn%2C%20ink%20wash%20mountain%20background%20with%20warm%20orange%20sunrise%20accents%2C%20sword%20reflecting%20golden%20light%2C%20refined%20classical%20art&width=420&height=580&seq=cover-jianming-03&orientation=portrait",
    isTop: true,
  },
  {
    id: "luori-zhicheng",
    title: "落日之城",
    genres: ["末世", "科幻", "剧情"],
    author: "白鹿原",
    status: "连载中",
    totalChapters: 198,
    latestChapter: 167,
    updateDay: "周二",
    rating: 9.2,
    heat: 7640,
    views: "1.8亿",
    synopsis: "文明黄昏之后，最后一座城市悬浮于残阳之上。少女守卫在废土与高塔之间，守护人类最后的火种。",
    cover: "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci%20fi%20manga%20cover%20of%20a%20lone%20survivor%20girl%20overlooking%20a%20ruined%20city%20under%20a%20huge%20setting%20orange%20sun%2C%20dramatic%20warm%20glow%2C%20melancholic%20yet%20hopeful%20atmosphere%2C%20detailed%20illustration&width=420&height=580&seq=cover-luori-04&orientation=portrait",
  },
  {
    id: "mitang-weiji",
    title: "蜜糖危机",
    genres: ["恋爱", "校园", "少女"],
    author: "甜饼研究所",
    status: "连载中",
    totalChapters: 124,
    latestChapter: 103,
    updateDay: "周四",
    rating: 9.3,
    heat: 7300,
    views: "2.5亿",
    synopsis: "转学生元气少女误打误撞进了全校最难搞的学霸社团，一段甜到发齁的青春恋爱故事就此展开。",
    cover: "https://readdy.ai/api/search-image?query=Cute%20shoujo%20romance%20manga%20cover%20of%20a%20blushing%20high%20school%20girl%20and%20boy%2C%20warm%20pastel%20pink%20and%20peach%20tones%2C%20soft%20sparkles%20and%20cherry%20blossoms%2C%20sweet%20youthful%20energy%2C%20clean%20anime%20style%20illustration&width=420&height=580&seq=cover-mitang-05&orientation=portrait",
  },
  {
    id: "guiying-zhentanshe",
    title: "诡影侦探社",
    genres: ["悬疑", "推理", "都市"],
    author: "陆离",
    status: "连载中",
    totalChapters: 156,
    latestChapter: 129,
    updateDay: "周六",
    rating: 9.4,
    heat: 7010,
    views: "1.6亿",
    synopsis: "只在午夜营业的侦探社，专接警方不接的灵异悬案。天才侦探与神秘助手，在层层迷雾中逼近真相。",
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20detective%20manga%20cover%20of%20a%20trench%20coat%20detective%20standing%20in%20night%20rain%2C%20warm%20city%20lights%20in%20background%2C%20suspenseful%20noir%20mood%2C%20shadowy%20atmosphere%20with%20orange%20street%20glow%2C%20detailed%20art&width=420&height=580&seq=cover-guiying-06&orientation=portrait",
  },
  {
    id: "jixie-xinzang",
    title: "机械心脏",
    genres: ["机甲", "科幻", "热血"],
    author: "废土机械师",
    status: "连载中",
    totalChapters: 210,
    latestChapter: 178,
    updateDay: "周一",
    rating: 9.1,
    heat: 6880,
    views: "1.9亿",
    synopsis: "少年飞行员的心跳与机甲引擎同频共振，在银河联邦的战场上，用一颗机械心脏点燃反抗的烽火。",
    cover: "https://readdy.ai/api/search-image?query=Mecha%20sci%20fi%20manga%20cover%20of%20a%20pilot%20inside%20a%20giant%20robot%20cockpit%2C%20warm%20orange%20energy%20core%20glowing%2C%20dynamic%20mecha%20design%2C%20dramatic%20lighting%2C%20detailed%20mechanical%20artwork&width=420&height=580&seq=cover-jixie-07&orientation=portrait",
  },
  {
    id: "huajian-ci",
    title: "花间词",
    genres: ["古风", "宫廷", "剧情"],
    author: "南巷听雨",
    status: "已完结",
    totalChapters: 142,
    latestChapter: 142,
    updateDay: "已完结",
    rating: 9.7,
    heat: 8890,
    views: "3.6亿",
    synopsis: "深宫红墙内，采诗女官以词寄情。一场权谋风暴中，她用一支笔写尽锦绣河山与儿女情长。",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20court%20manga%20cover%20of%20a%20graceful%20palace%20lady%20with%20flower%20crown%20holding%20a%20scroll%2C%20warm%20gold%20and%20red%20palace%20background%2C%20traditional%20watercolor%20style%2C%20refined%20and%20delicate&width=420&height=580&seq=cover-huajian-08&orientation=portrait",
    isTop: true,
  },
  {
    id: "shenhai-qiutu",
    title: "深海囚徒",
    genres: ["惊悚", "悬疑", "恐怖"],
    author: "鲸落",
    status: "连载中",
    totalChapters: 98,
    latestChapter: 77,
    updateDay: "周五",
    rating: 9.0,
    heat: 6540,
    views: "1.1亿",
    synopsis: "深海科考队意外唤醒远古海渊的囚徒。在黑暗与恐惧中，队员们必须找出逃离深渊的唯一生路。",
    cover: "https://readdy.ai/api/search-image?query=Dark%20ocean%20horror%20manga%20cover%20of%20a%20giant%20shadowy%20sea%20creature%20silhouette%20beneath%20deep%20water%2C%20cold%20teal%20with%20warm%20orange%20diving%20light%20contrast%2C%20eerie%20suspenseful%20mood%2C%20detailed%20atmospheric%20art&width=420&height=580&seq=cover-shenhai-09&orientation=portrait",
  },
  {
    id: "jingling-tiandianwu",
    title: "精灵甜品屋",
    genres: ["治愈", "日常", "奇幻"],
    author: "奶盖兔",
    status: "连载中",
    totalChapters: 88,
    latestChapter: 72,
    updateDay: "周日",
    rating: 9.4,
    heat: 6110,
    views: "1.4亿",
    synopsis: "森林精灵在人间开了家甜品屋，用魔法点心治愈每个疲惫的灵魂。软萌治愈的日常，甜到心底。",
    cover: "https://readdy.ai/api/search-image?query=Healing%20slice%20of%20life%20manga%20cover%20of%20a%20cute%20elf%20girl%20in%20a%20cozy%20pastel%20dessert%20shop%2C%20warm%20soft%20lighting%2C%20cakes%20and%20sweets%20on%20counter%2C%20gentle%20whimsical%20atmosphere%2C%20sweet%20and%20charming%20illustration&width=420&height=580&seq=cover-jingling-10&orientation=portrait",
  },
  {
    id: "dushi-juexing",
    title: "都市觉醒",
    genres: ["异能", "都市", "热血"],
    author: "峡谷猎手",
    status: "连载中",
    totalChapters: 190,
    latestChapter: 158,
    updateDay: "周二",
    rating: 9.1,
    heat: 7210,
    views: "2.2亿",
    synopsis: "大都市上空异象突现，觉醒者陆续现身。普通少年获得操控时间的异能，卷入守护城市的超能战争。",
    cover: "https://readdy.ai/api/search-image?query=Urban%20fantasy%20manga%20cover%20of%20a%20young%20man%20with%20glowing%20warm%20orange%20power%20in%20his%20hands%2C%20city%20skyline%20at%20golden%20hour%20background%2C%20energetic%20dynamic%20pose%2C%20colorful%20superhero%20style%20illustration&width=420&height=580&seq=cover-dushi-11&orientation=portrait",
  },
  {
    id: "lunhui-zhiyan",
    title: "轮回之眼",
    genres: ["玄幻", "热血", "剧情"],
    author: "时之砂",
    status: "连载中",
    totalChapters: 260,
    latestChapter: 226,
    updateDay: "周四",
    rating: 9.5,
    heat: 8620,
    views: "2.8亿",
    synopsis: "少年得到可看穿轮回的神之眼，踏入宗门与天下的纷争。看破生死轮回，斩断宿命枷锁。",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20xuanhuan%20manga%20cover%20of%20a%20young%20cultivator%20with%20a%20mysterious%20glowing%20eye%20symbol%2C%20swirling%20warm%20orange%20and%20red%20energy%2C%20dramatic%20dark%20background%2C%20epic%20powerful%20atmosphere&width=420&height=580&seq=cover-lunhui-12&orientation=portrait",
    isTop: true,
  },
];

export const categories = [
  { name: "热血冒险", icon: "ri-fire-fill", count: 328, color: "primary" },
  { name: "古风武侠", icon: "ri-knife-blood-fill", count: 215, color: "accent" },
  { name: "科幻机甲", icon: "ri-rocket-2-fill", count: 186, color: "secondary" },
  { name: "悬疑推理", icon: "ri-search-eye-fill", count: 142, color: "accent" },
  { name: "恋爱校园", icon: "ri-heart-3-fill", count: 267, color: "primary" },
  { name: "奇幻治愈", icon: "ri-sparkling-2-fill", count: 198, color: "secondary" },
  { name: "末世生存", icon: "ri-sun-cloudy-fill", count: 96, color: "primary" },
  { name: "都市异能", icon: "ri-flashlight-fill", count: 174, color: "accent" },
];

export const faqs = [
  {
    q: "番木瓜漫画的追更进度条是怎么同步的？",
    a: "番木瓜漫画的追更进度条会与连载作品的更新状态实时同步。只要作品更新了新的一话，你的阅读进度会自动刷新，并在进度条上清晰标记最新话数，让你一眼看清自己追到哪里、还差几话没看。",
  },
  {
    q: "热门榜单多久更新一次？",
    a: "热门榜单会综合人气、收藏、完读率等数据每 4 小时自动刷新一次，人气榜、新作榜和收藏榜同时更新。霸榜作品则是连续多周稳居榜首的连载，代表着当前最受欢迎的作品风向。",
  },
  {
    q: "长期连载的周更作品每周固定更新吗？",
    a: "大部分周更作品都有固定的更新日，我们会在每部作品的详情页和追更进度条上明确标注本周更新时间。若因特殊情况调整更新时间，我们会提前在作品页公告，确保你不会错过每一话。",
  },
  {
    q: "追更的作品可以设置更新提醒吗？",
    a: "可以的。把想追的作品加入追更列表后，每当它更新新话，首页追更进度条和消息中心都会即时提醒你，真正做到「周更不断、一话不落」。",
  },
  {
    q: "看漫画需要付费或注册吗？",
    a: "番木瓜漫画大量人气连载和榜单作品都可以免费试看。注册登录后可以同步追更进度、收藏作品并加入追更列表，让进度条跨设备保持一致。",
  },
];